// extracted by mini-css-extract-plugin
export var disabled = "_17-a";
export var hierarchyLinkGray = "_17-4";
export var hierarchyLinkUnderline = "_17-3";
export var hierarchyPrimary = "_17-0";
export var hierarchySecondary = "_17-1";
export var hierarchyTertiary = "_17-2";
export var pressed = "_17-6";
export var themeAction = "_17-5";
export var themeDestructive = "_17-8";
export var themeNormal = "_17-7";
export var themeSuccess = "_17-9";